import UserFormPage from "./user-form-page.jsx";

export default UserFormPage;
